import { render, staticRenderFns } from "./mgv1.vue?vue&type=template&id=1fe4d890&scoped=true"
import script from "./mgv1.vue?vue&type=script&lang=js"
export * from "./mgv1.vue?vue&type=script&lang=js"
import style0 from "./mgv1.vue?vue&type=style&index=0&id=1fe4d890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe4d890",
  null
  
)

export default component.exports